export default class UnmatchedBreakpointException extends Error {
    constructor(width) {
        const message = `Unable to determine breakpoint for provided width: ${width}`;
        super(message);
    }
}
